import { getHeaderElement } from './get-header-element';
import { isHeaderTransparent } from './is-header-transparent';

const topMenuSelector = '.top-menu';

export const getHeaderHeight = (): number => {
  let headerHeight = 0;
  const headerElement: HTMLElement | null = getHeaderElement();
  if (!headerElement) {
    return headerHeight;
  }

  if (isHeaderTransparent()) {
    const topMenuElement: HTMLElement | null = headerElement.querySelector(topMenuSelector);
    headerHeight = topMenuElement ? topMenuElement.scrollHeight : headerElement.offsetHeight;
  } else {
    headerHeight = headerElement.offsetHeight;
  }

  return headerHeight;
};
